import { render, staticRenderFns } from "./numberCenter.vue?vue&type=template&id=1362244f&scoped=true"
import script from "./numberCenter.vue?vue&type=script&lang=js"
export * from "./numberCenter.vue?vue&type=script&lang=js"
import style0 from "./numberCenter.vue?vue&type=style&index=0&id=1362244f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362244f",
  null
  
)

export default component.exports